import { UsersService } from '@/services/users.service'
import { GroupsService } from '@/services/groups.service'

export default {
  getCurrent ({ commit }) {
    return UsersService.getCurrent()
      .then(async user => {
        commit('SET_CURRENT_USER', user[0])
        const groups = await GroupsService.read(user[0].groups_id)
        const currentGroups = []
        for (let i = 0; i < groups.length; i++) {
          if (groups[i].name === 'Docentes') {
            currentGroups.push(groups[i].name)
          }
          if (groups[i].name === 'Coordinación') {
            currentGroups.push(groups[i].name)
          }
          if (groups[i].name === 'Dirección') {
            currentGroups.push(groups[i].name)
          }
          if (groups[i].name === 'Administrator') {
            currentGroups.push(groups[i].name)
          }
          if (groups[i].name === 'Billing') {
            currentGroups.push(groups[i].name)
          }
        }
        commit('SET_CURRENT_GROUPS', currentGroups)
      })
  },
  removeCurrent ({ commit }) {
    commit('REMOVE_CURRENT_USER')
  }
}
